'use strict';

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('InvoicePrintingController', ['$scope', '$http', '$rootScope', 'MeanUser', 'toaster', '$filter', 'TradeDrawService', 'ngDialog', 'aceUtils',
  function($scope, $http, $rootScope, MeanUser, toaster, $filter, TradeDrawService, ngDialog, aceUtils) {
    var vm = this;

    vm.selectedNode = null;
    vm.pageState = 'companyInfo';
    vm.project_invoices = null;
    vm.draw_items = [];
    vm.emails = [];

    vm.addCompanyEmail = function (newCompanyEmail) {
        if (aceUtils.isUndefinedOrNull(newCompanyEmail) || newCompanyEmail == '') return;

        vm.emails.push(newCompanyEmail);

        this.newCompanyEmail = '';
    };

    vm.viewDetails = function (index, text) {
        //this function gets called when the email modal is active
        //and sets some global variables for the edit functions
        vm.editEmailIndex = index;
        vm.editEmailText = text;
    };

    vm.acceptEditEmail = function () {
        if(vm.editEmailIndex == -1) return;

        vm.emails[vm.editEmailIndex] = vm.editEmailText;

        vm.editEmailIndex = -1;
        vm.editEmailText = null;
    };

    vm.cancelEditEmail = function () {
        vm.editEmailIndex = -1;
        vm.editEmailText = null;
    };

    vm.deleteEmail = function () {
        if(vm.editEmailIndex == -1) return;
        vm.emails.splice(vm.editEmailIndex, 1);

        vm.editEmailIndex = -1;
    };

    vm.printInvoice = function(project, node, invoice) {
        vm.just_print = true;
        console.log('project', project, node);
        //list = $filter('orderBy')(list, $scope.reportSortType);
        vm.buildPDF(project, node, invoice, 'Invoice');
    };

    vm.emailInvoie = function(project, node, invoice) {
        TradeDrawService.getEmails().then(function(emails) {
            vm.emails = emails;

            ngDialog.openConfirm({
                template: 'accounts-receivable/views/billing/email-selection-dialog.html',
                data: {
                    vm: vm
                },
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                vm.just_print = false;
                vm.buildPDF(project, node, invoice, 'Invoice');
                console.log('in the ok section');
            }, function (value) {
                //Do something
                //$scope.new_extra = false;
                console.log('in the do something section');
            });
        });
    };

    vm.printEstimate = function(project, node, estimate) {
        vm.just_print = true;
        console.log('project', project, node);
        //list = $filter('orderBy')(list, $scope.reportSortType);
        vm.buildPDF(project, node, estimate, 'Estimate');
    };

    vm.emailEstimate = function(project, node, estimate) {
        TradeDrawService.getEmails().then(function(emails) {
            vm.emails = emails;

            ngDialog.openConfirm({
                template: 'accounts-receivable/views/billing/email-selection-dialog.html',
                data: {
                    vm: vm
                },
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                vm.just_print = false;
                vm.buildPDF(project, node, estimate, 'Estimate');
                console.log('in the ok section');
            }, function (value) {
                //Do something
                //$scope.new_extra = false;
                console.log('in the do something section');
            });
        });
    };

    vm.buildPDF = function(project, node, doc, docType) {
        var data = doc.details;

        var invoiceNo = (docType == 'Estimate')? doc.number : doc.code;

        var test = {
            //pageMargins: [ 10, 70, 10, 20 ],
            pageSize: 'A4',
            Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Medium.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-Italic.ttf'
            },
            header: [
                { 
                    canvas: [{ 
                        type: 'line', 
                        x1: 10, 
                        y1: 10, 
                        x2: 595-10, 
                        y2: 10, 
                        lineWidth: 0.5 
                    }] 
                },
                {
                   fontSize: 12,
                   columns : [{
                        text : docType + '-' + invoiceNo, 
                        margin : [ 10,0,0,0 ], 
                        width : 300
                    }]
                },
                { 
                    canvas: [{ 
                        type: 'line', 
                        x1: 10, 
                        y1: 0, 
                        x2: 595-10, 
                        y2: 0, 
                        lineWidth: 0.5 
                    }]
                }
            ],
            footer: function(currentPage, pageCount) { 
                return [
                    { 
                        canvas: [{ 
                            type: 'line', 
                            x1: 10, 
                            y1: 10, 
                            x2: 595-10, 
                            y2: 10, 
                            lineWidth: 0.5 
                        }] 
                    },
                    {
                       fontSize: 8,
                       columns : [{
                            text : 'Generated using', 
                            margin : [ 10,0,0,0 ], 
                            width : 100
                        }]
                    },
                    {
                        fontSize: 8,
                        columns : [{
                            text : 'A.C.E. Construction Software', 
                            margin : [ 10,0,0,0 ], 
                            width : 200
                        },
                        {
                            text: currentPage.toString() + ' of ' + pageCount,
                            margin : [ 0,0,10,0 ], 
                            alignment: 'right'
                        }
                        ]
                    },
                ]
            },
            content: [{
                fontSize: 10,
                columns: [[{ 
                    text: docType + ' For: ', 
                    bold: true
                },
                {
                    table: {
                        widths: ['auto', '*'],
                        body: [
                            ['Company Name:', node.builder_name],
                            ['Company Address:', node.builder_address_one + '\n' + node.builder_address_two]
                        ]
                    },
                    layout: 'noBorders'
                }
                ], [{ 
                    text: docType + ' From: ', 
                    bold: true
                },
                {
                    table: {
                        widths: ['auto', '*'],
                        body: [
                            ['Company Name:', node.trade_name],
                            ['Company Address:', node.trade_address_one + '\n' + node.trade_address_two]
                        ]
                    },
                    layout: 'noBorders'
                }
                ]],
                    columnGap: 10
                },
                ' ',
                {
                fontSize: 10,
                columns: [[{ 
                    text: 'Project Info: ', 
                    bold: true
                },
                {
                    table: {
                        widths: ['auto', '*'],
                        body: [
                            ['Project Name:', project.name],
                            ['Project Number:', node.job_code + '-' + node.phase],
                            ['Project Address:', project.contact.address_one + '\n' + project.contact.city + ', ' + project.contact.state + ' ' + project.contact.zip]
                        ]
                    },
                    layout: 'noBorders'
                }
                ], [{ 
                    text: docType + ' #: ', 
                    bold: true
                },
                {
                    text: invoiceNo
                },
                ' ', 
                { 
                    text: 'Date: ', 
                    bold: true
                },
                {
                    text: $filter('date')(new Date((docType == 'Estimate')?doc.date:doc.invoice_date),'MM/dd/yyyy')
                }
                ]],
                    columnGap: 10
                },
                ' ',
                {
                fontSize: 10,
                columns: [[{ 
                    text: 'Phase Info: ', 
                    bold: true
                },
                {
                    table: {
                        widths: ['auto', '*'],
                        body: [
                            ['Phase Number:', doc.phase]
                        ]
                    },
                    layout: 'noBorders'
                }
                ], [{ 
                    
                }
                ]],
                    columnGap: 10
                },
                ' ',
                (doc.type == 'option') ?
                    vm.table(data, ['description', 'lot', 'plan', 'contract', 'amount'])
                    :
                    vm.table(data, ['description', 'lot', 'plan', 'task_code', 'amount'])
                    ,
                ' ',
                ' ',
                {
                    fontSize: 10,
                    columns: [
                        [
                            
                        ]
                    ,
                        [
                            'Total:             $ ' + doc.amount.toFixed(2).toString()
                        ]
                    ],
                    columnGap: 10
                }
            ],
                defaultStyle: {
                    font: 'Roboto'
            }
        }

        // var taskCode = $scope.selectedReport.task_code;
        // var devDate = new moment($scope.selectedReport.delivery_date).format('MMM D, YYYY : HH:mm')

        var fileName = docType + '-' + invoiceNo + '.pdf';

        if(vm.just_print) {
            pdfMake.createPdf(test).open();
            vm.just_print = false;
        } else {
            pdfMake.createPdf(test).getBase64(function(buffer) {
                if (vm.emails.length > 0) {
                    var data = ({
                        to: vm.emails,
                        subject: node.trade_name + ' ' + docType + ' (' + invoiceNo + ')',
                        message: 'Attached is an ' + docType + ' for ' + node.trade_name + '<br>' + 
                            '<br><br><br>This report is created using A.C.E. Construction Software.<br>' +
                            'Please do not reply to this email and contact the contractor if you have any questions.',
                        fileName: fileName,
                        attachment: buffer
                    });
    
                    $http.post('/api/sendPhaseReports', data).
                      success(function(data, status, headers, config) {
                        console.log('Message was successfully sent');
                      }).
                      error(function(data, status, headers, config) {
                        console.log('There was an error with the message');
                    });
                }

                // save to invoice into document
                var projectData = {
                    phase: node.phase,
                    project_id: project._id
                };

                projectData.fileName = docType + '-' + invoiceNo + '.pdf';
                projectData.folderTitle = 'Billing Info';
                projectData.uploadedBy = $scope.user.username;
                projectData.attachment = buffer;
                projectData.mainAccountId = $scope.mainAccountID;
                $http.post('/api/materialReport', projectData).
                  success(function(data, status, headers, config) {
                    toaster.pop('success', 'Invoice Saved', 'Invoice successfully saved into document.');
                    console.log('Report uploaded successfully');
                  }).
                  error(function(data, status, headers, config) {
                    console.log('There was an error with the message');
                });
                
            });
        }
    };

    vm.buildTableBody = function(data, columns) {
        var body = [];
        var formatted = [];

        _.each(columns, function(column) {
            formatted.push(column.split('_').join(' ').toUpperCase());
        });

        body.push(formatted);

        _.each(data, function(row) {
            var dataRow = [];

            _.each(columns, function(column) {
                if(column === 'amount') {
                    dataRow.push('$ ' + row[column].toFixed(2).toString());
                } else if(column === 'contract') {
                    dataRow.push('$ ' + row[column].toFixed(2).toString());
                } else {
                    dataRow.push(row[column].toString());
                }
            });

            body.push(dataRow);
        });

        return body;
    };

    vm.table = function(data, columns) {
        return [{
            margin: [40, 0],
            table: {
                headerRows: 1,
                body: vm.buildTableBody(data, columns)
            },
            fontSize: 10
        }];
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/invoicePrinting.js